import {useNavigate} from "react-router-dom";
import {useContext, useEffect} from "react";
import {GateContext} from "../../tools/contexts/GateContext";
import LoadingScreen from "../LoadingScreen";
import servicesRoute from "../../tools/servicesRoute";

const DivarInternalEstate = () => {
    const navigate = useNavigate();

    const {
        id,
        serviceType,
        postToken,
        returnUrl,
        loading,
        handleLoading,
        handleGetPlatformLink,
        code,
        handlePlatformGuard
    } = useContext(GateContext);

    useEffect(() => {
        if (code) {
            const params = {
                "service_type": serviceType,
                "platform_hash_id": id,
                "post_token": sessionStorage.getItem('post_token'),
                "code": code
            }
            handlePlatformGuard(params,(data)=>{
                sessionStorage.setItem('token', data.access_token);
                sessionStorage.setItem('platformUser', JSON.stringify(data.platform_user));
                sessionStorage.setItem('service_type', serviceType);
                navigate(servicesRoute[serviceType].path, {
                    state: {
                        access_token: data.access_token,
                        platform: data.client_name,
                        platform_user: data.platform_user,
                        mobile: data.platform_user.phone_number,
                        defaultService: serviceType,
                    }, replace: true
                })
            });
        } else {
            handlePlatformLink()
        }
    }, []);
    const handlePlatformLink = () => {
        localStorage.clear();
        sessionStorage.clear();
        if (id) {
            sessionStorage.setItem('id', id)
        }
        if (returnUrl) {
            sessionStorage.setItem('return_url', returnUrl)
        }
        if (postToken) {
            sessionStorage.setItem('post_token', postToken)
        }
        const params = {
            "service_type": serviceType,
            "platform_hash_id": id,
            "post_token":postToken,
        }
        console.log(params)
        handleLoading(true)
        handleGetPlatformLink(params);
    }
    if (loading) {
        return <LoadingScreen/>
    }
    return <></>
}
export default DivarInternalEstate;